// extracted by mini-css-extract-plugin
module.exports = {"main":"Table2_main__3S9MH","headertxt":"Table2_headertxt__k1L5n","list":"Table2_list__35G0R","firstItemBold":"Table2_firstItemBold__1-sUM","link":"Table2_link__3RM4J"};